
const custom = function() {
    const cardBlockLink = function(){
        const sourceLink = document.querySelectorAll('.card-block-link');
        sourceLink.forEach(element => {
            element.addEventListener('click', function(){
                window.location.href = this.dataset.link;
            })
        })
    }

    const headerMobileSearch = function(){
        document.addEventListener('click', function(e){
            const searchOverlay = document.querySelector('.header__icons .search-overlay')
            if(e.target == searchOverlay){
                document.querySelector('.mobile-view .header__icon-search').click();
            }
        })
    }

    return {
        init : function() {
            cardBlockLink();
            headerMobileSearch();
        }
    }
}();

document.addEventListener('DOMContentLoaded', ()=> {
    custom.init();
})


const ATCUiHandler = (function () {

  return {
    setQuantity,
    showQuantity,
    hideQuantity,
    showTrashOrMinus,
    handleMinMaxWording
  }

  function setQuantity(el, value) {
    el.querySelector('.quantity__input').value = value;
  }

  function showQuantity(el) {
    showTrashOrMinus(el);
    el.querySelector('.bb_qty-selector').classList.remove('bb-hidden');
    el.querySelector('.bb_atc-wrap').classList.add('bb-hidden');
  }

  function hideQuantity(el) {
    el.querySelector('.bb_qty-selector').classList.add('bb-hidden');
    el.querySelector('.bb_atc-wrap').classList.remove('bb-hidden');
  }

  function showTrashOrMinus(el) {
    const target = el.querySelector('.quantity__input');
    const elTrash = el.querySelector('.btn__trash');
    const elMinus = el.querySelector('.btn__minus');

    const qty = target.value;
    let min = parseInt(target.dataset.minAllowed);

    if (isNaN(min) || min == 0) {
      min = 1;
    }

    if (qty <= min) {
      elMinus.classList.add('bb-hidden');
      elTrash.classList.remove('bb-hidden');
    } else {
      elMinus.classList.remove('bb-hidden');
      elTrash.classList.add('bb-hidden');
    }
  }

  function handleMinMaxWording(target, qty) {
      const elMinMaxWording = target.closest('.bb_qty-atc').querySelector(".min-max-description");
      const minAllowed = parseInt(target.dataset.minAllowed);
      const maxAllowed = parseInt(target.dataset.maxAllowed);

      elMinMaxWording.classList.remove('bb-hidden');

      if (minAllowed && maxAllowed) {
        if (qty >= maxAllowed) {
          elMinMaxWording.innerHTML = `Max ${maxAllowed} per order`;
        } else {
          elMinMaxWording.innerHTML = `Min ${minAllowed} per order`;
        }

        return;
      }

      if (minAllowed) {
        elMinMaxWording.innerHTML = `Min ${minAllowed} per order`;
        return;
      }

      if (maxAllowed) {
        elMinMaxWording.innerHTML = `Max ${maxAllowed} per order`;
        return;
      }

        elMinMaxWording.innerHTML = `&nbsp;`;
        elMinMaxWording.classList.add('bb-hidden');

    }
}());
  
const ATCHandler = (function () {

  cartTimers = {};

  return {
    init,
    updateCartItem
  }

  ////////////////////////////////////////////////////////////////////////////

  function init() {
    registerPageEventHandlers();
    registerRebuyEventHandlers();
    enableCartIcon();
  }

  function registerPageEventHandlers() {
    _registerAtcClickHandler();
    _registerVariantChangeHandler();
    _registerQtyInputChangeHandler();
  }

  function enableCartIcon() {
    document.querySelector('.header__icon--cart').classList.remove('inactive');
  }

  function registerRebuyEventHandlers() {
    document.addEventListener('rebuy:cart.change', (event) => { 
        // console.log("cart change", event.detail);
        updateCartSummary(event.detail); 

        function updateCartSummary(cartDetails) {  
          document.querySelectorAll('.cart-count-bubble .cart_item-count').forEach(ele =>{
              ele.innerHTML = cartDetails.cart.cart.item_count;
          })
          
          const rebuyCartItems = cartDetails.cart.cart.items;
          const combinedRebuyCartItems = _combineDuplicates(cartDetails.cart.cart.items);

          combinedRebuyCartItems.forEach(item => {
              const cardItems = document.querySelectorAll(`[name='id'][value='${item.variant_id}']`);
              cardItems.forEach(cardItem => {
                  if (item.quantity) {
                    ATCUiHandler.setQuantity(cardItem.closest('.bb_qty-atc'), item.quantity);
                    ATCUiHandler.showQuantity(cardItem.closest('.bb_qty-atc'));
                  }
              })
          })
    
          if (rebuyCartItems.length == 0) {
            const prodCards = document.querySelectorAll('.bb_qty-atc')
            prodCards.forEach(item => {
              ATCUiHandler.setQuantity(item, 0);
              ATCUiHandler.hideQuantity(item);
            })
          }
        }  
    });

    document.addEventListener("rebuy:smartcart.line-item-removed", (event) => {
        const smartcart = event.detail.smartcart;
        const item = event.detail.item;
        
        const cardItems = document.querySelectorAll(`[name='id'][value='${item.variant_id}']`);
        cardItems.forEach(item => {
          ATCUiHandler.hideQuantity(item.closest('.bb_qty-atc'));
        })
    });
  }

  ////////////////////////////////////////////////////////////////////////////

  function _combineDuplicates(items) {
    return Object.values(
        items.reduce((acc, product) => {
            if (!acc[product.variant_id]) {
                acc[product.variant_id] = { ...product };
            } else {
                acc[product.variant_id].quantity += product.quantity;
            }
            return acc;
        }, {})
    );
  }

  /**
   * We need to take into account we can have multiple cart line items for same variant ID
   * This can happen if we run Buy X gt Y discounts
   */
  async function updateCartItem(updatesArray) {
    const responseFetch = await fetch('/cart.js');
    const cart = await responseFetch.json();

    let data = {};

    for (const [variantID, quantity] of Object.entries(updatesArray)) {
        let totalQuantity = 0;

        const matchingLineItems = cart.items.filter((item) => item.variant_id == variantID)
        if (matchingLineItems.length) {
          totalQuantity = matchingLineItems.reduce((acc, item) => acc + item.quantity, 0);
        }

        const deltaQuantity = quantity - totalQuantity;

        // get 1st line item for variant id
        const firstMatchingItem = cart.items.find(item => item.variant_id == variantID);
        const key = firstMatchingItem ? firstMatchingItem.key : null;

        const updateQuantity = firstMatchingItem.quantity + deltaQuantity;

        if (!key) {
          data[String(variantID)] = updateQuantity
        } else {
          data[String(key)] = updateQuantity
        }
    }
    
    const responseUpdate = await fetch('/cart/update.js',
      {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify({updates: data})
      }
    );
    
    await responseUpdate.json();
  }

  function _registerAtcClickHandler() {
    document.addEventListener("click", function (e) {
      if (!e.target || !e.target.matches(".bb_qty-atc .bb_atc-wrap .bb_atc.one-option")) {
        return;
      }

      const target = e.target;
      e.preventDefault();

      const variantID = target.closest('form').querySelector('[name="id"]').value;

      const inputTarget = target.closest('.bb_qty-atc').querySelector(".bb_qty-selector .quantity__input");
      const minAllowed = parseInt(inputTarget.dataset.minAllowed);
      let qty = 1;
      if (minAllowed) {
        qty = minAllowed;
      }

      ATCUiHandler.handleMinMaxWording(inputTarget, qty);

      let data = {
          "id" : variantID,
          "quantity" : qty
      }
  
      fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify(data)
      })
      .then(response => {
          return response.json();
      })
      .then(data => {
        ATCUiHandler.setQuantity(target.closest('.bb_qty-atc'), 1);
        ATCUiHandler.showQuantity(target.closest('.bb_qty-atc'));
        Rebuy.SmartCart.show();
      })
      .catch((error) => {
          console.error('Error:', error);
      })      
    });
  }

  function _registerVariantChangeHandler() {
    document.addEventListener("variantChange", function (e) {
      
      const variantIdEls = document.querySelectorAll(`.product-atc-wrapper form[data-type='add-to-cart-form'] input[name='id']`);
      variantIdEls.forEach(el => { 
        el.value = e.detail.id;
      });

      fetch('/cart.js', {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
        }
      })
      .then(response => {
          return response.json();
      })
      .then(data => {
        const matchingLineItems = data.items.filter((item) => item.id == e.detail.id)
        if (matchingLineItems.length) {
          const totalQuantity = matchingLineItems.reduce((acc, item) => acc + item.quantity, 0);

          document.querySelectorAll('.product-atc-wrapper .bb_qty-atc').forEach(el => {
            ATCUiHandler.setQuantity(el, totalQuantity);
          });
          document.querySelectorAll('.product-atc-wrapper .bb_qty-atc').forEach(el => {
            ATCUiHandler.showQuantity(el);
          });
        } else {          
          document.querySelectorAll('.product-atc-wrapper .bb_qty-atc').forEach(el => {
            ATCUiHandler.hideQuantity(el);
          });
        }

        document.querySelector('product-info .bb_qty-atc quantity-input').validateQtyRules(); // global.js QuantityInput custom element
      })
      .catch((error) => {
          console.error('Error:', error);
      })      

    });
  }

  function _registerQtyInputChangeHandler() {
    document.addEventListener("change", function(e) {
      if (!e.target || !e.target.matches(".bb_qty-atc .bb_qty-selector .quantity__input")) {
        return;
      }

      const target = e.target;
      const prodId = target.closest('.bb_qty-atc').querySelector(".bb_atc-wrap [name='id']").value;

      if (cartTimers.hasOwnProperty(prodId)) {
        clearTimeout(cartTimers[prodId]);
      }

      let qty = parseInt(target.value);
      const minAllowed = parseInt(target.dataset.minAllowed);
      const maxAllowed = parseInt(target.dataset.maxAllowed);

      if (minAllowed && qty < minAllowed) {
        qty = 0;
      }

      e.preventDefault();


      ATCUiHandler.showTrashOrMinus(target.closest('.bb_qty-atc'));
      ATCUiHandler.handleMinMaxWording(target, qty);

      if (qty < 1) {
        ATCUiHandler.hideQuantity(target.closest('.bb_qty-atc'));

        const atcElement = target.closest('.bb_qty-atc').querySelector('.bb_atc-wrap');
        atcElement.classList.add('no-pointer-events');
        setTimeout(() => {
            atcElement.classList.remove('no-pointer-events');
        }, 500);
      }

      cartTimers[prodId] = setTimeout(() => {
        updateCartItem({ [prodId]: qty });
      }, 700);
    });
  }
})();

const MultiVariantHandler = (function () {

  return {
    init
  }

  ////////////////////////////////////////////////////////////////////////////

  function init() {
    _registerPageEventHandlers();
  }

  ////////////////////////////////////////////////////////////////////////////

  function _registerPageEventHandlers() {
    document.addEventListener("click", function(e) {
      if (!e.target || !e.target.matches(".bb_qty-atc .bb_atc-wrap .bb_atc.select-option")) {
        return;
      }

      const target = e.target;
      e.preventDefault();

      _onVariantSelect();
    });
  }

  function _onVariantSelect() {
      let timeoutId; 

      function checkAndAppend() {
          document.querySelector('quick-add-modal.quick-add-modal[open]')?.classList.add('is-active');
          const prodActive = document.querySelector('quick-add-modal.quick-add-modal[open].is-active');

          if (prodActive) {
              clearTimeout(timeoutId);
          } else {
              timeoutId = setTimeout(checkAndAppend, 1000);
          }
      } 

      timeoutId = setTimeout(checkAndAppend, 1000);
  }
})();

const stickyAnnouncementBar = () => {
  const headerHeight = document.querySelector('.section-header').offsetHeight;
  document.querySelector('.shopify-section.announcement-bar-section').style.top = `${headerHeight - 1}px`;
}

document.addEventListener('DOMContentLoaded', ()=>{
    ATCHandler.init();
    MultiVariantHandler.init();
})

document.querySelectorAll('a[href="#cookiebot"]').forEach(link => {
  link.addEventListener('click', function(event) {
      event.preventDefault();
      Cookiebot.renew();
  });
});


// Timer banner custom element implementation
class TimerBanner extends HTMLElement {
  constructor() {
    super();
    this.timerDisplay = this.querySelector('.timer-banner__time');
    this.endTime = null;
    this.interval = null;
    this.initialized = false;
  }
  
  connectedCallback() {
    if (this.timerDisplay) {
      const endTimeStr = this.timerDisplay.dataset.timer;
      if (endTimeStr) {
        this.endTime = new Date(endTimeStr).getTime();
        this.startTimer();
      }
    }
  }
  
  disconnectedCallback() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
  
  startTimer() {
    this.updateTimer();
    this.interval = setInterval(() => this.updateTimer(), 1000);
  }
  
  updateTimer() {
    const now = new Date().getTime();
    const distance = this.endTime - now;
    
    if (distance <= 0) {
      clearInterval(this.interval);
      // Find and hide the entire timer banner element
      const timerBannerContainer = this.closest('.l-timer-banner');
      if (timerBannerContainer) {
        timerBannerContainer.style.visibility = 'hidden';
      }
      return;
    }
    
    // Calculate total hours (including days), minutes and seconds
    let totalHours = Math.floor(distance / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    
    // Format with leading zeros
    const formatNumber = (num) => num.toString().padStart(2, '0');
    
    // Format as "XXh XXm XXs" with hardcoded prefix
    this.timerDisplay.textContent = `${formatNumber(totalHours)}h ${formatNumber(minutes)}m ${formatNumber(seconds)}s`;
    
    // After timer is calculated and active, make the container visible
    if (!this.initialized) {
      const timerBannerContainer = this.closest('.l-timer-banner');
      if (timerBannerContainer) {
        timerBannerContainer.style.visibility = 'visible';
      }
      this.initialized = true;
    }
  }
}

// Register the custom element
if (!customElements.get('timer-banner')) {
  customElements.define('timer-banner', TimerBanner);
}
